import ToolbarLogo from '@flows/src/components/ui/advisory-flow/components/toolbar/ToolbarLogo';
import {
  Center,
  VStack,
  Icon,
  Link,
  Text,
  HStack,
} from '@wegroup/design-system';
import { FC, useContext } from 'react';
import { ThemeContext } from 'styled-components';
import { useTranslation } from 'react-i18next';
import { Link as RouterLink } from 'react-router-dom';
import useAuth from '../../../../app/src/features/authentication/hooks/useAuth';

const FlowProductsSideBarLogo: FC = () => {
  const { distribution } = useAuth();
  const theme = useContext(ThemeContext);
  const { t } = useTranslation();

  const logoUrl = distribution?.logos?.logo || theme.branding?.logo;

  return (
    <VStack spacing="4" mb="8" px="4">
      <Center maxW="3xs" mx="auto">
        <ToolbarLogo url={logoUrl} />
      </Center>
      <Center>
        <Link
          as={RouterLink}
          to="/dashboard"
          color="gray.600"
          _hover={{ color: 'primary.500', textDecoration: 'none' }}
          fontSize="sm"
          fontWeight="medium"
        >
          <HStack spacing="2" align="center">
            <Icon name="GeneralActionsArrowLeft" />
            <Text>{t('BACK-TO-DASHBOARD')}</Text>
          </HStack>
        </Link>
      </Center>
    </VStack>
  );
};

export default FlowProductsSideBarLogo;
